import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProductsMapList from "../ProductsMapList";

const FourGrid = ({ currentProductId, handleOpenDrawer }) => {
  const productList = useSelector((state) => state.productslst?.products || []);
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {

    if (productList.length > 1) {
      const updatedProducts = productList.filter(
        (product) => product.id !== currentProductId
    ).slice(0, 4);

      setFilteredProducts(updatedProducts);
    }
  }, [currentProductId, productList]);

  return (
    <div>
      {(productList.length > 1) && <h2 className="section-title">You May Also Like</h2>}
       { (productList.length > 1) && 
      <div className="products-grid">
        {filteredProducts.length > 0 ? (
          <ProductsMapList productList={filteredProducts} handleOpenDrawer={handleOpenDrawer} />
        ) : (
          <p className="no-products">No Record Found!</p>
        )}
      </div>
      }
    </div>
  );
};

export default FourGrid;